import { FC, useRef, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useMapsLibrary } from "@vis.gl/react-google-maps";

interface MapAddressSearchProps {
    onPlaceSelected: (lat: number, lng: number, address?: string) => void;
}

const MapAddressSearch: FC<MapAddressSearchProps> = ({ onPlaceSelected }) => {

    const placesLib = useMapsLibrary("places");

    const inputRef = useRef<HTMLInputElement | null>(null);
    const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);

    const [value, setValue] = useState("");

    useEffect(() => {

        if (!placesLib || !inputRef.current || autocompleteRef.current) return;

        autocompleteRef.current = new placesLib.Autocomplete(
            inputRef.current,
            {
                fields: ["formatted_address", "geometry", "name"],
                types: ["geocode"],
                componentRestrictions: { country: ["au", "cx", "cc", "nf", "fk"] }
            }
        );

        autocompleteRef.current.addListener("place_changed", () => {

            const place = autocompleteRef.current?.getPlace();

            if (!place?.geometry?.location) return;

            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();

            const address = place.formatted_address ?? place.name ?? "";

            setValue(address);

            onPlaceSelected(lat, lng, address);
        });

    }, [placesLib, onPlaceSelected]);

    return (
        <TextField
            size="small"
            inputRef={inputRef}
            value={value}
            placeholder="Search address..."
            onChange={(e) => setValue(e.target.value)}
            sx={{
                width: "85px",
                background: "white",
                borderRadius: "4px",
                transition: "width 0.3s ease",
                "&:focus-within": {
                    width: {
                        xs: "100%",
                        sm: "280px",
                    }
                }
            }}
        />
    );
};

export default MapAddressSearch;